<template>
  <div class="flex-col page space-y-12">
    <div class="flex-col">
      <div class="flex-col section">
        <!-- <div class="flex-row group space-x-6">
          <div class="section_2"></div>
          <span class="font_1">地块属性</span>
        </div>
        <div class="flex-col group group_2 space-y-10">
          <div class="flex-row justify-between items-center list-item" v-for="(item, index) in items" :key="index">
            <div class="flex-row items-baseline space-x-16">
              <span class="font_3 text_2">
                <van-field v-bind="item.props" v-model="item.value" :label="item.label" :clickable="true" :placeholder="`请${item.type==='picker' ?'选择': '输入' }${item.label}`" @click="()=>{ item.click && item.click(item) }" />
              </span>
            </div>
            <img class="image_2" v-if="item.type==='picker'" src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/64489f9d5a7e3f0310f71776/6461034fb98f5d0011697b8a/16927697775549696401.png" />
          </div>
        </div> -->
        <div class="flex-row group view space-x-6">
          <div class="section_2"></div>
          <span class="font_1 text_7">灌溉指导</span>
        </div>
        <div class="flex-row justify-between items-center group_3">
          <span class="font_4 text_8">{{ cgqInfo.name || data.name }}</span>
          <div class="flex-row items-center space-x-4">
            <img class="shrink-0 image_3" src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/64489f9d5a7e3f0310f71776/6461034fb98f5d0011697b8a/16927697775535902151.png" />
            <span class="font_5 text_9">预警值：{{ items_1[1].value || 0 }}-{{ uper || 0 }}-kPa</span>
          </div>
        </div>
        <div class="flex-col group group_4 space-y-10">
          <div class="flex-row items-center list-item_2 space-x-18" v-for="(item, index) in items_1" :key="index">
            <!-- <span class="font_2">{{item.label}}</span> -->
            <!-- <span class="font_6 text_10">{{ item.value }}</span> -->
            <van-field v-model="item.value" :label="item.label" :clickable="true" :placeholder="`请输入${item.label}`" />
          </div>
        </div>
        <div class="flex-row justify-between items-center group view_2">
          <div class="flex-row space-x-6">
            <div class="shrink-0 section_2"></div>
            <span class="font_1">果径计划值设置</span>
          </div>
          <div class="flex-col justify-start items-center button"><span class="font_5 text_11" @click="handleAdd">新增</span></div>
        </div>
        <div class="flex-col list">
          <div class="flex-row justify-between relative list-item_3 section_3">
            <div class="font_7 text_12 time">时间</div>
            <div class="font_7 text_13 value ">果径值</div>
            <div class="font_7   unit">单位</div>
            <div class="font_7 text_15 pos_2 ac">操作</div>
          </div>
          <div v-if="items_2.length">
            <div class="flex-row justify-between relative list-item_3 section_3" v-for="(item, index) in items_2" :key="index">
              <div class="font_7 text_12 time">
                <van-field v-model="item.planDate" :clickable="true" :disabled="true" placeholder="请选择时间" @click="() => handleDateClick(index)" />
              </div>
              <div class="font_7 text_13 value ">
                <van-field v-model="item.planFruitDiam" type="number" :disabled="true" placeholder="请填写" />
              </div>
              <div class="font_7   unit">
                <van-field v-model="item.diamUnit" :disabled="true" placeholder="请填写" />
              </div>
              <div class="font_7 text_15 pos_2 ac" style="color:#3364DB">
                <span v-if="!item.isAdd" @click="handleModify(item)"> 修改</span>
                &nbsp;&nbsp;
                <span @click="handleRemove(item)">删除</span>
              </div>
            </div>
          </div>
          <div v-else class="noData">暂无数据</div>
        </div>
      </div>
    </div>
    <div class="flex-col items-center" :style="{ position: 'fixed', bottom: '20px', left: 0, right: 0, }">
      <div class="flex-col justify-start items-center button_2" @click="handleSave"><span class="font_4 text_20">保存</span>
      </div>
    </div>

    <!-- 当前发育期 -->
    <van-popup v-model="birthDatePickerVisible" round position="bottom">
      <van-picker title="生育期" show-toolbar :columns="columns" v-model="birthDatePickerValue" @cancel="birthDatePickerVisible = false" @confirm="onBirthDatePick" />
    </van-popup>

    <van-popup v-model="datePickerVisible" round position="bottom">
      <van-datetime-picker title="选择日期" type="date" @confirm="handleDateConfirm" @cancel="datePickerVisible = false" />
    </van-popup>

    <van-dialog v-model="showPlanDialog" title="果径计划" :show-cancel-button="false" :show-confirm-button="false" className="planDialogClass">
      <div v-for="(item, index) in planItem" :key="item.label" style="padding: 10px 30px;">
        <van-field v-model="item.value" :label="item.label" :placeholder="item.key == 'date' ? '请选择时间' : `请输入${item.label}`" @click="() => { if (item.key == 'planDate') { handleDateClick(index) } }" />
      </div>

      <div class="btns flex-row items-center">
        <div @click="showPlanDialog = false">取消</div>
        <div @click="handleSubmitPlan" style="color:red">确定</div>
      </div>
    </van-dialog>

  </div>
</template>

<script>
import moment from 'moment';
import { Dialog } from 'vant';
export default {
  components: {},
  props: {},
  data () {
    return {
      birthDatePickerVisible: false,
      birthDatePickerIndex: null,
      birthDatePickerValue: null,
      datePickerVisible: false,
      items: [
        { key: 'birthDate', label: '当前生育期', value: '', type: 'picker', click: () => { this.birthDatePickerVisible = true; } },
        { key: 'farm', label: '土壤质地', value: '', props: { maxlength: 50 } },
        { key: 'year', label: '生成年份', value: '', props: { maxlength: 50 } },
        { key: 'breed', label: '植物品种', value: '', props: { maxlength: 50 } },
        { key: 'treeAge', label: '植物树龄', value: '', props: { maxlength: 50 } },
      ],
      items_1: [
        { key: 'min', label: '最小预警值', value: '', },
        { key: 'ganhan', label: '干旱预警值', value: '', },
        { key: 'max', label: '最大预警值', value: '', },
      ],
      items_2: [],
      columns: ["春梢萌发", "现蕾", "盛花期", "座果", "果实膨大", "转色", "成熟期", "清园"],
      chooseDateIndex: null,

      oldItem: null,
      data: {},
      lower: null,
      uper: null,
      farmInfo: {},
      cgqInfo: {},
      planItem: [
        { key: 'planDate', label: '日期', value: '', },
        { key: 'planFruitDiam', label: '果径值', value: '', },
        { key: 'diamUnit', label: '单位', value: 'mm', },
      ],
      showPlanDialog: false
    };
  },

  async mounted () {
    const no = localStorage.getItem('no')
    this.no = no

    const data = JSON.parse(sessionStorage.getItem("liveSettingData"));
    const deviceType = sessionStorage.getItem('deviceType')
    const { lowerLimit, uperLimit } = data
    this.lower = lowerLimit
    this.uper = uperLimit
    this.items_1[0].value = lowerLimit
    this.items_1[2].value = uperLimit
    this.cgqInfo = { ...data }

    await this.getQueryFarm()
    this.getHold(data)


    if (this.farmInfo.myCropList?.length) {
      this.planFruitId = this.farmInfo.myCropList[this.farmInfo.myCropList?.length - 1].id
      this.queryPlanFruit()
    }

    console.log("  this.farmInfo?.myCropList:", this.farmInfo?.myCropList);


  },

  methods: {
    // 读取传感器阈值
    getHold (data) {
      try {
        this.$api.getHold({ channelNo: data.channelNo, no: this.no })
          .then(res => {
            console.log(res);
            if (res.errcode == 0) {
              if (this.$isblank(res.no)) {
                this.lowerLimit = "";
                this.uperLimit = "";
              } else {
                const { channelName, channelNo, no, lowerLimit, uperLimit, id } = res;
                const { index, unit, value, uuid, sensor } = data;
                const d = { name: channelName, channelNo, no, index, lowerLimit, uperLimit, id, unit, value, uuid, sensor };

                this.data = { ...data, ...d };
                this.lower = lowerLimit;
                this.uper = uperLimit;

                this.items_1[0].value = lowerLimit
                this.items_1[2].value = uperLimit
              }
            } else {
              this.$toast.clear();
              this.$toast(res.errmsg);
            }
          })
          .catch(err => {
            console.log(err);
            // 其他异常
            this.$toast.clear();
            this.$toast(this.$t("common.timeout"));
          });
      } catch (err) {
        console.error(err);
      }
    },

    // 读取果径计划
    queryPlanFruit (id) {
      this.$api.queryPlanFuit(this.planFruitId).then(res => {
        this.items_2 = res.planFuit.map(item => {
          if (typeof item.planDate == 'number') {
            item.planDate = moment(item.planDate).format("YYYY-MM-DD")
          }
          return item
        })

      })
    },

    async getQueryFarm () {
      await this.$api.queryFarm(this.no).then(res => {
        if (res.errcode == 0) {
          this.farmInfo = res.data
          if ("extData" in this.farmInfo) {
            this.farmInfo.extData = JSON.parse(this.farmInfo.extData)

            if (this.farmInfo.extData?.data) {
              const findIndex = this.items_1.findIndex(o => o.key === 'ganhan')

              // 查找对应传感器的 干旱值
              const find = this.farmInfo.extData.data.find(o => o.channelNo == this.cgqInfo.channelNo)
              if (find) {
                this.items_1[findIndex].value = find.ganhan
              }
            } else {
              this.farmInfo.extData.data = []
            }
          } else {
            this.farmInfo.extData = { data: [] }
          }
        } else {
          this.$toast({
            message: res.errmsg,
            duration: 2000
          })
        }
      })
    },

    onBirthDatePick (value,) {
      const index = this.columns.indexOf(value);
      this.birthDatePickerIndex = index
      this.items[0].value = value
      this.birthDatePickerVisible = false
    },

    // 点击时间
    handleDateClick (index) {
      this.datePickerVisible = true
    },

    // 添加
    handleAdd () {
      this.planItem.map(item => {
        item.value = null
      })
      this.showPlanDialog = true
    },

    // 修改
    handleModify (data) {
      this.planItem.map(item => {
        if (item.key === 'diamUnit') {
        } else { item.value = data[item.key] }
        item.id = data.id
        item = Object.assign(item, data)
      })
      this.showPlanDialog = true
    },

    // 删除
    handleRemove (data) {
      Dialog.confirm({ title: '删除', message: '确定要执行此操作吗？' }).then(() => {
        console.log('确认');
        // 删除
        this.$api.deletePlanFruit(data.id).then(res => {
          this.$toast({ message: '删除成功' })
          this.queryPlanFruit()
          this.showPlanDialog = false

        })

      }).catch(() => {
        // 用户点击取消按钮后的逻辑
        console.log('取消');
      });
    },


    handleDateConfirm (value) {
      console.log(value);
      this.planItem[0].value = moment(value).format("YYYY-MM-DD")
      this.datePickerVisible = false
    },


    async handleSubmitPlan () {
      const obj = {
        "cropId": this.farmInfo?.myCropList?.[this.farmInfo?.myCropList?.length - 1]?.id
      }


      const t = this.planItem.find(item => {
        obj[item.key] = item.value
        obj.id = item.id
        obj.cropId = item.cropId ?? obj.cropId
        return !item.value
      })

      if (t) {
        this.$toast({ message: '计划未填写完整' })
      } else {
        if (obj.id == null) { delete obj.id }
        if (obj.cropId == null) { delete obj.cropId }
        obj.planDate = new Date(obj.planDate).getTime()
        // 保存果径计划
        await this.$api.savePlanFruit(obj).then(res => {
          if (res.errcode == 0) {
            this.$toast({ message: obj.id ? '修改成功' : '新增成功' });
            this.queryPlanFruit()
            this.showPlanDialog = false
          } else {
            this.$toast({ message: res.errmsg })
          }
        })
      }
    },

    // 保存
    async handleSave () {
      // 设置阈值
      const obj = {}
      this.items_1.map(item => {
        obj[item.key] = item.value
      })

      const { min: lower, max: uper, ganhan } = obj;

      if (!lower || !uper || !ganhan) {
        return this.$toast({ message: '请填写完整预警阀值' })
      }

      console.log("Number(ganhan):", Number(ganhan), Number(uper), Number(ganhan) < Number(uper));

      if (Number(lower) < Number(ganhan) && Number(ganhan) < Number(uper)) {
      } else {
        return this.$toast({ message: '预警阀值填写不正确,最小预警值 < 干旱预警值 < 最大预警值', duration: 2000 })
      }

      this.$toast.loading({
        message: this.$t("common.loading"),
        forbidClick: true,
        duration: 0
      });
      const { no, index, id, channelNo, uuid } = this.data;
      const param = {
        channelNo,
        no,
        lowerLimit: Number(lower),
        uperLimit: Number(uper),
        index,
        id,
        isNotify: false, // 是否通知
        notifyWay: "" // 1 微信，2 电话，3 邮箱
      };

      //设备类型 20 三代传感器
      if (this.deviceType == 20) {
        param.uuid = uuid
        param.sensorId = this.data?.ext?.id
      }


      const findIndex = this.farmInfo?.extData?.data?.findIndex(o => o.channelNo === channelNo)
      if (findIndex > -1) { this.farmInfo.extData.data[findIndex].ganhan = ganhan }
      else {
        this.farmInfo.extData.data.push({ ganhan, channelNo })
      }

      // 保存扩展字段
      await this.saveExtData(this.farmInfo.extData.data)

      this.$api.setHold({ ...param }).then(res => {
        this.$toast.clear();
        if (res.errcode === 0) { this.$toast.success('修改成功'); }
        else { this.$toast(res.errmsg); }
      }).catch(err => {
        console.log(err);
        // 其他异常
        this.$toast.clear();
        this.$toast(this.$t("common.timeout"));
      });



    },

    // 保存扩展字段
    saveExtData (data) {
      this.$api.setFarmExtData({ farmId: this.farmInfo.id, extData: { data } }).then(res => {
        if (res.errcode == 0) {
          console.log("保存干旱阀值成功");
        } else {
          this.$toast(`保存地块扩展信息错误: ${res.errmsg}`);
        }
        this.$toast.clear();
      }).catch(err => {
        console.error(err)
        this.$toast.clear();
        this.$toast('请求发生错误');
      });
    }

  },
}
</script>

<style lang="scss" scoped>
@import "./../codeFunCommon.scss";
@import "./index.scss";

::v-deep .van-field__label {
  margin: 0;
  background-color: #f8f8f8;
  color: #646566 !important;
}

::v-deep .items-baseline {
  width: calc(100% - 30px);
  margin: 0;
  justify-content: unset;
  background-color: #f8f8f8;

  input {
    color: #3364db;
  }
}

::v-deep .van-field__body,
::v-deep .van-field {
  background-color: #f8f8f8;
  padding: 0;
}
</style>
